module.exports = __webpack_public_path__ + "static/media/horse.a16f38e4.png";